<template>
  <v-hover v-slot="{ hover }">
    <v-card
      height="100%"
      overflow="hidden"
      class="d-flex flex-column flex-grow-1 "
      :elevation="hover ? 16 : 2"
      :class="[`degree-${infoItem.caseSourceId}`,{ 'on-hover': hover }]"
      @click="$emit('card-click',infoItem)"
    >
      <div class="d-flex font-weight-black header-text ">
        <div class="pa-3 ml-auto text-c-dark d-flex  flex-wrap">
          <div>
            <v-icon
              large
              color="var(--app-primary-color)"
              class="ml-1"
            >
              {{ icon }}
            </v-icon>
            <span class="case-update-card-header"> {{ header }} </span>
          </div>

          <span
            v-if="status"
            style=" height:fit-content;  overflow-wrap: anywhere;"
            class="status pa-1 mt-1 mr-2 "
          > {{ status }}
          </span>
        </div>
        <div
          v-if="hasActions"
          class="mt-2"
        >
          <slot
            name="actions"
            :item="infoItem"
          />
        </div>
      </div>

      <template>
        <slot
          name="top-slot"
          :item="infoItem"
        />
      </template>

      <div
        v-if="code"
        class="row px-2 header-text"
      >
        <div class="py-1 text-c-green col-4">
          {{ codeDisplayName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="code"
        >
          {{ code }}
        </div>
      </div>

      <div
        v-if="type"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ typeDisplayName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="type"
        >
          {{ type }}
        </div>
      </div>
      <div
        v-if="courtName"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ local.home.tabCommon.courtName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="courtName"
        >
          {{ courtName }}
        </div>
      </div>
      <div
        v-if="subCircleName"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ local.home.tabCommon.subCircleName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="subCircleName"
        >
          {{ subCircleName }}
        </div>
      </div>

      <template>
        <slot
          name="bottom-slot"
          :item="infoItem"
        />
      </template>

      <v-divider class="mt-5 mb-0"></v-divider>

      <div class="d-flex justify-end font-weight-black text-c-green dateDisplayName mt-auto">
        <div
          v-if="date"
          class="px-1 pa-3 ml-auto dateDisplayName"
        >
          {{ dateDisplayName }}
          <span class="text-c-lite mr-1"> {{ toHijriDate(date) }}</span>
        </div>
        <div
          v-if="infoItem.caseSourceId"
          class="px-2 pa-3"
        >
          <span :class="`degree-text-${infoItem.caseSourceId}`"> {{ caseDegrees[infoItem.caseSourceId] }}</span>
        </div>

        <template>
          <slot
            name="bottom-button-slot"
            :item="infoItem"
          />
        </template>
      </div>
    </v-card>
  </v-hover>
</template>

<script>

import { caseDegrees } from '@/helpers/enum';
import { toHijriDate, getTimePartArabic, getTimePart, getTime12Format, isAm, getTimeSlot } from '@/helpers/utils';

export default {
  name: 'BankruptcyCard',
  components: {},
  props: {
    infoItem: {
      default: null,
      type: Object,
      required: true,
    },
    icon: {
      default: null,
      type: String,
      required: true,
    },
    header: {
      default: null,
      type: String,
      required: true,
    },
    codeDisplayName: {
      default: null,
      type: String,
      required: false,
    },
    code: {
      default: null,
      type: [String, Number],
      required: false,
    },
    statusDisplayName: {
      default: null,
      type: String,
      required: false,
    },
    status: {
      default: null,
      type: String,
      required: false,
    },
    typeDisplayName: {
      default: null,
      type: String,
      required: false,
    },
    type: {
      default: null,
      type: String,
      required: false,
    },
    dateDisplayName: {
      default: null,
      type: String,
      required: true,
    },
    date: {
      default: null,
      type: String,
      required: true,
    },
    hasActions: {
      default: false,
      type: Boolean,
      required: true,
    },
    subCircleName: {
      default: null,
      type: String,
      required: false,
    },
    courtName: {
      default: null,
      type: String,
      required: false,
    },
  },
  data() {
    return {
      caseDegrees,
      getTimePart,
      getTime12Format,
      isAm,
      getTimeSlot,
    };
  },
  computed: {},
  methods: {
    getTimePartArabic,
    toHijriDate,
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  font-weight: normal;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

.text-c-green {
  color: var(--app-primary-color);
}

.text-c-dark {
  color: var(--app-dark-primary-color);
}

.text-c-lite {
  color: #a6b8bb;
  font-size: 16px;
  font-weight: bold;
}
.dateDisplayName {
  font-size: 16px;
  font-weight: normal;
}
.text-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}

.degree-1 {
  border: 2px solid #97dfdf;

  .degree-text-1 {
    color: #97dfdf;
    font-size: 16px;
    font-weight: bolder;
  }
}

.degree-2 {
  border: 2px solid var(--app-primary-color);

  .degree-text-2 {
    color: var(--app-primary-color);
    font-size: 16px;
    font-weight: bolder;
  }
}

.degree-3 {
  border: 2px solid var(--app-dark-primary-color);

  .degree-text-3 {
    color: var(--app-dark-primary-color);
    font-size: 16px;
    font-weight: bolder;
  }
}
.copy-icon {
  font-size: 20px;
}
.videoConferenceUrl {
  color: var(--app-primary-color);
  cursor: pointer;
}
.status {
  color: #29af5b;
  background: #d1efdd;
  border-radius: 5px !important;
  padding: 3px;
  font-size: 12px;
}
.fixed-card {
  min-height: 350px;
  max-height: 350px;

}
</style>
